<template>
  <v-sheet :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'">
    <v-container class="main-container responsive-height">
      <v-row dense>
        <v-col cols="12">
          <div class="titleName mt-5 mb-7 d-flex align-center">
            <v-img class="mr-3" max-width="17" src="@/assets/Dashboard/bar.svg"></v-img>
            <span>Transaction History</span>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" xl="12">
          <v-card elevation="0" class="all-trade-tab rounded-0 ma-0"
            :class="$vuetify.theme.dark ? 'blue-darken-2' : 'transparent'">
            <v-tabs :background-color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'
              " class="pa-0">
              <v-tab v-for="(tab, index) in generateLevelsArray" :key="index"
                @click="levelFilterTransactionReports(index)">{{ tab }}</v-tab>

              <v-tab-item v-for="(tab, index) in generateLevelsArray" :key="index">
                <v-card flat>
                  <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'
                    ">
                    <v-row dense>
                      <v-col cols="12" sm="6" md="6" lg="4">
                        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search trade number ..."
                          single-line solo hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="2">
                        <v-select solo :items="slots" v-model="selectedTransactionType" append-icon="mdi-chevron-down"
                          label="All Trx. Type" class="custom-select" @change="trxFilterTransactionReports"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="3">
                        <v-dialog ref="dialog" v-model="modal" :return-value.sync="selectedDates" width="290px"
                          class="">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar"
                              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
                              class="custom-select"></v-text-field>
                          </template>
                          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
                            <v-spacer></v-spacer>
                            <v-btn class="error-text-lighten-1" text @click="cancelSelection">
                              Cancel
                            </v-btn>
                            <v-btn text @click="confirmSelection"> OK </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="3">
                        <ul>
                          <li>
                            <span class="text--ash">Deposit:</span>
                            <span>{{ transactionReports?.totalDeposit }}</span>
                          </li>

                          <li>
                            <span class="text--ash">Withdraw:</span>
                            <span>{{
                              transactionReports?.totalWithdrawal
                            }}</span>
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="12">
                        <v-card class="pa-0 rounded-0 elevation-0" :class="$vuetify.theme.dark
                            ? 'blue-darken-5'
                            : 'white-lighten-2'
                          ">
                          <v-sheet class="transactionTable pb-0" :class="$vuetify.theme.dark
                              ? 'blue-lighten-1'
                              : 'white-lighten-1'
                            ">
                            <v-data-table :headers="headers" :items="transactionReports?.reports" :search="search"
                              :items-per-page="10">
                              <template v-slot:item.amount="{ item }">
                                <span :class="verifyIcon(item?.trx_type?.toLowerCase())
                                  ">{{ item.amount }}</span>
                              </template>
                            </v-data-table>
                          </v-sheet>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CLIENTTRANSACTIONREPORTS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      slots: ["All", "Deposit", "Withdrawal", "Internal Transfer"],
      selectedTransactionType: null,
      selectedTransactionLevel: null,
      selectedDates: [],
      selectedDatesText: null,
      modal: false,
      headers: [
        {
          text: "Client Name",
          align: "start",
          value: "name",
        },
        { text: "Date", value: "created_at" },
        { text: "IB Code", value: "client_account_id" },
        { text: "Account No.", value: "trading_account_no" },
        { text: "Trx Type", value: "trx_type" },
        { text: "Amount($)", value: "amount" },
      ],
    };
  },
  computed: {
    ...mapState("transactionReports", ["transactionReports"]),

    generateLevelsArray() {
      const levelsArray = [];
      for (let i = 0; i < this.transactionReports?.businessLevel; i++) {
        levelsArray.push(`Level ${i + 1}`);
      }
      return ["All Level", ...levelsArray];
    },
  },
  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },
    ...mapActions("transactionReports", [
      CLIENTTRANSACTIONREPORTS__ACTIONS.TRANSACTIONREPORTS,
    ]),

    verifyIcon(trxType) {
      if (trxType === "deposit") {
        return "text--green";
      } else if (trxType === "Withdrawal") {
        return "text--red";
      } else {
        return "#55afef";
      }
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }
      const parameter = {
        level:
          this.selectedTransactionLevel === 0
            ? null
            : this.selectedTransactionLevel,
        trx_type:
          this.selectedTransactionType === "All"
            ? null
            : this.selectedTransactionType,

        duration:
          startDate.toISOString().split("T")[0] +
          "to" +
          endDate.toISOString().split("T")[0],
      };

      this[CLIENTTRANSACTIONREPORTS__ACTIONS.TRANSACTIONREPORTS](parameter);
      this.modal = false;
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },

    async levelFilterTransactionReports(level) {
      this.selectedTransactionLevel = level;

      const parameter = {
        level: level === 0 ? null : level,
        trx_type:
          this.selectedTransactionType === "All"
            ? null
            : this.selectedTransactionType,
      };

      this[CLIENTTRANSACTIONREPORTS__ACTIONS.TRANSACTIONREPORTS](parameter);
    },

    async trxFilterTransactionReports() {
      const parameter = {
        level:
          this.selectedTransactionLevel === 0
            ? null
            : this.selectedTransactionLevel,
        trx_type:
          this.selectedTransactionType === "All"
            ? null
            : this.selectedTransactionType,
      };

      this[CLIENTTRANSACTIONREPORTS__ACTIONS.TRANSACTIONREPORTS](parameter);
    },
  },
  mounted() {
    this[CLIENTTRANSACTIONREPORTS__ACTIONS.TRANSACTIONREPORTS]();
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>
